/**
 * Convenience HTMLElement for gracefully loading an image.
 * Most of its effects are done via CSS.
 * @param {string} [src] - Image URI.
 */
export default function LazyImage(src) {
	let timeout = null
	const element = document.createElement('ui-image')

	const display = document.createElement('div')
	display.classList.add('display')
	element.appendChild(display)

	element.appendChild(document.createElement('ui-spinner'))

	const image = new Image()
	image.onload = function () {
		clearTimeout(timeout)
		display.style.backgroundImage = `url('${image.src}')`
		element.classList.add('loaded')
	}

	/**
	 * @param {string} src - Image URI.
	 * @param {number} delay - Delay until actually loading the image. For transition reasons.
	 */
	element.setImage = function (src, delay = 0) {
		element.classList.remove('loaded')
		clearTimeout(timeout)
		timeout = setTimeout(() => {
			image.src = src
		}, delay)
	}

	if (src) {
		element.setImage(src)
	}

	return element
}
